export enum RootStates {
  Initializing = 'initializing',
  Unauthenticated = 'unauthenticated',
  Authenticated = 'authenticated',
}
